// Get the modal

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("my_Modal");
  const modalImg = document.getElementById("img01");
  const previewContainer = document.querySelector(".preview-img-container");

  // Get all images with the class "myImg"
  var imgs = document.querySelectorAll(".myImg");

  // Loop through each image and add a click event listener
  imgs.forEach(function (img) {
    img.addEventListener("click", function () {
      modal.style.display = "block";
      const previewImage = this.cloneNode(true);
      previewContainer.appendChild(previewImage);
      previewImage.classList.add("modal-img");
      console.log(previewImage);
      document.body.style.overflow = "hidden"; // Disable scroll
      modal.style.overflow = "auto";
    });
  });

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // Close the modal when clicking the close button
  span.onclick = function () {
    handleModalClose();
  };

  // Close the modal when clicking outside the image
  modal.onclick = function (event) {
    if (event.target === modal) {
      handleModalClose(); // Restore scroll
    }
  };

  // Close the modal when pressing the Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      handleModalClose();
    }
  });

  function handleModalClose() {
    modal.style.display = "none";
    previewContainer.innerHTML = "";
    document.body.style.overflow = "auto"; // Restore scroll;

    modal.style.overflow = "hidden";
  }

  // end
});
